import { Translation } from '@ngneat/transloco';
import { get } from 'lodash-es';

import { Columns } from '#types/grid';

export function translateColumnHeaders(columns: Columns, translations: Translation, passThruLabels?: Record<string, string>): Columns {
  function translate(key: string): string {
    return get(translations, key, key);
  }

  for (const column of columns) {
    column.header = translate(column.key);
  }

  if (passThruLabels) {
    const labels = Object.keys(passThruLabels);

    for (const column of columns) {
      const field = column.field.toUpperCase();

      if (labels.includes(field)) {
        column.header = passThruLabels[field] ?? column.header;
      }
    }
  }

  return [...columns];
}
